// Route the console's own windows are mounted under, outside the dashboard
// shell — today, a lane popped out to a second screen.
export const CONSOLE_BASE_PATH = '/console';

// Where the bitácora lives inside the dashboard shell. A window of the console
// that has nothing to show sends the viewer back here.
export const LOGBOOK_PATH = '/monitoring/console';
